import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingsState } from "../types/setting";
import { SearchDefaultValue, SearchValue } from "./types";

const initialState: SettingsState = {
  searchValue: SearchDefaultValue,
  isActive: true,
};

export const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<SearchValue>) => {
      state.searchValue.name = action.payload.name;
    },
    setIsActive: (state) => {
      state.isActive = !state.isActive;
    },
  },
});

export const { setSearchValue, setIsActive } = settings.actions;

export const selectSearchValue = (state: { settings: SettingsState }) =>
  state?.settings?.searchValue;
export const selectIsActive = (state: { settings: SettingsState }) =>
  state?.settings?.isActive;

export default settings.reducer;
